/**
 * Die Status-Ableitung der Produktflächen — EINE Quelle für Detailseite,
 * Bundle-Seite und Produkttabelle.
 *
 * 🔴 **Warum sie umgezogen ist (2026-10-13).** Sie lag bis dahin in
 * `ProductDetail.jsx`. Die Produkttabelle (`components/ProductsTable.jsx`)
 * braucht denselben Chip; ein Import aus `./ProductDetail` risse aber den in
 * `App.js:110-113` ausdrücklich **lazy** gehaltenen ProductDetail-Teilbaum in
 * das Hauptbündel — `ProductsOverview` und damit `ProductsTable` werden eifrig
 * geladen (`App.js:39`). `ProductDetail.jsx` re-exportiert die Funktion darum
 * unverändert weiter; die bestehenden Aufrufer bleiben unberührt.
 */

/**
 * Der Status-Chip der Produktseite als reine Ableitung — die normale Seite und
 * die Bundle-Seite lesen ihn von hier, damit „Draft" auf beiden dasselbe heisst.
 * Verhalten 1:1 aus dem früheren `useMemo` in ProductDetail übernommen.
 *
 * 🔴 **`unlisted` hat hier bereits ein Etikett** („Unlisted", Farbe `default`) —
 * es entsteht aus dem Rohwert (`:317-318`). `draft`/`archived` tragen `warning`,
 * `unlisted` `default`. Die Farbe ist nie die Aussage: der Chip trägt Text
 * (Regel 22 Nr. 2).
 */
export function productStatusInfo(product) {
  if (!product) return null;
  const primary = product.product_status;
  const fallback =
    product.status ??
    product.workflow_status ??
    product.state ??
    (product.archived ? "archived" : null);
  const raw = (primary || fallback || "").toString().trim();
  if (!raw) {
    if (product.is_active === false) return { label: "inactive", color: "warning" };
    return null;
  }
  const lower = raw.toLowerCase();
  let color = "default";
  if (["active", "live", "published"].some((token) => lower.includes(token))) {
    color = "success";
  } else if (["draft", "archiv", "inactive", "disabled"].some((token) => lower.includes(token))) {
    color = "warning";
  }
  const display = raw.charAt(0).toUpperCase() + raw.slice(1);
  return { label: display, color };
}
